import React, { memo } from "react";
import { ConfigProvider, DatePicker } from "antd";
import datePickerLocale from "antd/lib/locale/pt_BR";
import moment from "moment";

import BreadCrumbNavigation from "../../components/DataTable/TopSection/BreadCrumbNavigation";
import LoadingElevaty from "../../components/LoadingElevaty";
import useOperationPeaks from "../../hooks/useOperationPeaks/useOperationPeaks";
import OperationPeaksChart from "./OperationPeaksChart";
import * as S from "./styles";

const OperationPeaksDashboard = () => {
  const {
    selectedDate,
    setSelectedDate,
    data,
    loading,
    handleApplyFilters,
  } = useOperationPeaks();

  return (
    <S.Container data-testid="operation-peaks-dashboard">
      <BreadCrumbNavigation
        preTableName="Configurações / Indicadores"
        tableName="Dashboard de Picos de Operação"
      />

      <S.TitleWrapper>
        <S.PageTitle>Dashboard de Picos de Operação</S.PageTitle>
      </S.TitleWrapper>

      <S.FilterCard data-testid="operation-peaks-filter-card">
        <S.FilterRow>
          <S.FilterField>
            <label htmlFor="operation-peaks-date">Filtros de Período</label>
            <ConfigProvider locale={datePickerLocale}>
              <DatePicker
                id="operation-peaks-date"
                data-testid="operation-peaks-date-picker"
                value={selectedDate}
                onChange={(date) => date && setSelectedDate(date)}
                format="DD/MM/YYYY"
                allowClear={false}
                disabledDate={(current) => current && current > moment().endOf("day")}
              />
            </ConfigProvider>
          </S.FilterField>

          <S.ApplyButton
            type="button"
            data-testid="operation-peaks-apply-filters-button"
            onClick={handleApplyFilters}
            disabled={loading}
          >
            Aplicar Filtros
          </S.ApplyButton>
        </S.FilterRow>
      </S.FilterCard>

      <S.ChartCard data-testid="operation-peaks-chart-card">
        <S.ChartHeader>
          <S.ChartTitle>
            Volume de Atendimentos Iniciados por Faixa Horária (Barra)
          </S.ChartTitle>

          {data && (
            <S.SummaryBadge data-testid="operation-peaks-summary-badge">
              Resumo do Dia | Total de Atendimentos:{" "}
              <strong>{data.total.toLocaleString("pt-BR")}</strong>
            </S.SummaryBadge>
          )}
        </S.ChartHeader>

        {loading ? (
          <S.EmptyState data-testid="operation-peaks-loading">
            <LoadingElevaty />
          </S.EmptyState>
        ) : data ? (
          <OperationPeaksChart hourly={data.hourly} />
        ) : (
          <S.EmptyState data-testid="operation-peaks-empty-state">
            Selecione uma data e clique em &quot;Aplicar Filtros&quot; para
            visualizar o gráfico.
          </S.EmptyState>
        )}
      </S.ChartCard>
    </S.Container>
  );
};

export default memo(OperationPeaksDashboard);
